// Nombre visible de una company (username + apellido, o el email como fallback).
// Mismo patrón usado en toda la app para poblar selects/listados de companies.
export const companyLabel = c =>
  `${c?.username || ''} ${c?.userlastname || ''}`.trim() || c?.usermail || '';
